import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _2 from 'lodash';
import { mapMutations, mapState, mapActions } from 'vuex';
import Node from './node.vue';
import MenuSortDialog from '../template/menu-sort-dialog/index.vue';
import MenuTransferDialog from '../template/menu-transfer-dialog';
import { hasPermission } from '../template/auth.js';
import ResetJsonConfig from './reset-json-config.vue';
import ResetTemplate from './reset-template.vue';
import { isGamePlay, isElementStars, isGameConfigStars, isGameDifficultyCategory, isFrameSequence, isDragonBones, isElement, isLangPack, isSceneList } from '../utils';
import animateScrollTo from 'animated-scroll-to';
import globalEventBus, { events } from '@/event';
import isMaterialWarehouse from '@/common/is-warehouse.js';
import { categoryConfig, findCatgeory, gameDifficultyCategoryConfig, i18nCategoryResourceType } from '@/store/creative/common/category';
import V2OutlineBd from './v2-outline/bd.vue';

var categoryIcons = [{
  // 引导环节
  id: categoryConfig.startScene.id,
  icon: 'cat_lead'
}, {
  // 试玩环节
  id: categoryConfig.gameScene.id,
  icon: 'cat_hand'
}, {
  // 结束环节
  id: categoryConfig.endingScene.id,
  icon: 'cat_end'
}, {
  id: categoryConfig.autoEndTime.id,
  icon: 'cat_time'
}, {
  id: categoryConfig.playAgain.id,
  icon: 'cat_operation_time_limit'
}, {
  id: gameDifficultyCategoryConfig.easy.id,
  icon: 'cat_easy_game_config'
}, {
  id: gameDifficultyCategoryConfig.medium.id,
  icon: 'cat_medium_game_config'
}, {
  id: gameDifficultyCategoryConfig.hard.id,
  icon: 'cat_hard_game_config'
}, {
  id: categoryConfig.multiCustomCategory.id,
  icon: 'cat_multi'
}];

var getCurrentIcon = function getCurrentIcon(node, _ref) {
  var currentTab = _ref.currentTab;

  // 二级标题不要 icon，暂时不删除代码，暂时不处理，先返回空
  if (node.level === 2) return '';

  var iconUtils = {
    2: function _(node) {
      var currentIcon = categoryIcons.find(function (item) {
        return item.id === node.id;
      });

      if (currentIcon && _2.isString(currentIcon.icon)) {
        return currentIcon.icon;
      }

      if (isElementStars(node.id) || isGameConfigStars(node.id)) {
        return 'collect';
      }

      if (isLangPack({ prefix: node.prefix, resourceType: node.resource_type })) {
        return 'cat_earth';
      }

      if (isGamePlay(node.pid)) {
        // 如果 playable 中的 gameConfig 中配置了 icon，就使用该 icon，如果没有就使用默认的
        if (node.icon) return 'cat_' + node.icon;
        return 'cat_game_config_default';
      }

      return '';
    },

    3: function _(node) {
      // 玩法三级分类不需要 icon
      if (currentTab === 3) return '';

      if (node.resource_type === 'group') {
        return 'cat_folder';
      }
      if (node.file_type === 'image' || isDragonBones(node.prefix) || isFrameSequence(node.prefix, node.resource_type)) {
        return 'cat_image';
      }
      if (node.file_type === 'audio') {
        return 'cat_audio';
      }
      if (node.file_type === 'video') {
        return 'cat_video';
      }
      if (node.resource_type === i18nCategoryResourceType) {
        return 'cat_word';
      }
      return 'cat_others';
    }
  };

  return iconUtils[node.level] ? iconUtils[node.level](node) : '';
};

export default {
  components: {
    Node: Node,
    MenuSortDialog: MenuSortDialog,
    MenuTransferDialog: MenuTransferDialog,
    ResetJsonConfig: ResetJsonConfig,
    ResetTemplate: ResetTemplate,
    V2OutlineBd: V2OutlineBd
  },

  props: {
    category: {
      type: Array,
      required: true
    },

    validate: {
      type: Function,
      default: function _default() {}
    },

    verifying: {
      type: Boolean,
      default: false
    },

    page: [String],

    menuTransferDialog: Object
  },

  data: function data() {
    return {
      currentCategoryList: []
    };
  },


  computed: _extends({}, mapState({
    gameConfigResource: function gameConfigResource(state) {
      return state.creative.template.gameConfigResource || null;
    },
    isCommonTemplateCustom: function isCommonTemplateCustom(state) {
      return state.creative.template.isCommonTemplateCustom;
    },
    groupsConfig: function groupsConfig(state) {
      return state.creative.template.groupsConfig;
    },
    currentTab: function currentTab(state) {
      return state.creative.template.currentTab;
    },
    activeCategoryId: function activeCategoryId(state) {
      return state.creative.template.activeCategoryId;
    },
    permissionKeys: function permissionKeys(state) {
      return state.creative.template.permissions;
    },
    isV2: function isV2(state) {
      return state.creative.template.isV2;
    }
  }), {
    isElementTab: function isElementTab() {
      return isElement(this.currentTab);
    },
    isGameConfigTab: function isGameConfigTab() {
      return isGamePlay(this.currentTab);
    },
    starsCategoryList: function starsCategoryList() {
      if (this.isElementTab) {
        return this.currentCategoryList.filter(function (item) {
          return isElementStars(item.id);
        });
      }
      if (this.isGameConfigTab) {
        return this.currentCategoryList.filter(function (item) {
          return isGameConfigStars(item.id);
        });
      }
      return null;
    },
    commonCategoryList: function commonCategoryList() {
      if (this.isElementTab) {
        return this.currentCategoryList.filter(function (item) {
          return !isElementStars(item.id);
        });
      }
      if (this.isGameConfigTab) {
        return this.currentCategoryList.filter(function (item) {
          return !isGameConfigStars(item.id);
        });
      }
      return this.currentCategoryList;
    },
    hdVisible: function hdVisible() {
      return this.category.filter(function (item) {
        return item.visible;
      }).length > 1;
    },
    gameDifficultyList: function gameDifficultyList() {
      return _2.get(this.gameConfigResource, 'gameDifficultyList') || [];
    },
    currentNodeKey: function currentNodeKey() {
      return this.activeCategoryId;
    },
    isShowSortButton: function isShowSortButton() {
      return hasPermission({
        key: 'category.sort',
        permissionKeys: this.permissionKeys
      });
    },
    isTemplateResettable: function isTemplateResettable() {
      return hasPermission({
        key: 'template-resettable',
        permissionKeys: this.permissionKeys
      }) || false;
    },
    isTemplateJsonResettable: function isTemplateJsonResettable() {
      return hasPermission({
        key: 'template-json-resettable',
        permissionKeys: this.permissionKeys
      }) || false;
    },
    isCategoryMovable: function isCategoryMovable() {
      return hasPermission({
        key: 'category.move',
        permissionKeys: this.permissionKeys
      }) || false;
    },
    isShowResetButton: function isShowResetButton() {
      var _this = this;

      return [1, 3].some(function (item) {
        return item === _this.currentTab;
      }) && (this.isTemplateResettable || this.isTemplateJsonResettable);
    },
    isShowTransferButton: function isShowTransferButton() {
      return this.isCategoryMovable;
    },
    renderContent: function renderContent() {
      var _this2 = this;

      var h = this.$createElement;

      return {
        functional: true,
        render: function render(h, ctx) {
          var node = ctx.props.node;
          var currentIcon = getCurrentIcon(node, {
            currentTab: _this2.currentTab
          }) || '';
          var canBeStar = node.canBeStar;

          var dcoCategoryArrowRight = function dcoCategoryArrowRight() {
            var validateIsConfigured = function validateIsConfigured() {
              return (_this2.gameDifficultyList || []).find(function (item) {
                return item.tag === node.tag;
              });
            };

            if (isGameDifficultyCategory(node.id)) {
              var isConfigured = validateIsConfigured();
              return h(
                'span',
                {
                  'class': 'dco-category-node-right ' + (isConfigured ? 'configured' : '')
                },
                [isConfigured ? _this2.$t('playTurbo.gamePlay.difficulty.configured') : _this2.$t('playTurbo.gamePlay.difficulty.configure'), h(
                  'svg-icon',
                  {
                    'class': 'arrow_right',
                    attrs: { iconClass: 'arrow_right'
                    }
                  },
                  []
                )]
              );
            }

            return null;
          };

          var iconEle = function iconEle(icon) {
            if (icon) {
              return h(
                'svg-icon',
                { 'class': 'node-icon', attrs: { iconClass: icon }
                },
                []
              );
            }

            // dco icon
            if (hasPermission({
              key: 'category.dco-info',
              permissionKeys: _this2.permissionKeys
            }) && (node.dco_part_id > 0 ||
            // 查看组的子项是否有 dco
            node.resource_type === 'group' && node.group_items.some(function (item) {
              return item.dco_part_id > 0;
            }))) {
              return h(
                'span',
                { 'class': 'dco-icon' },
                ['[DCO]']
              );
            }

            return null;
          };

          return h(
            'div',
            { 'class': 'node-label' },
            [iconEle(currentIcon), node.pid === categoryConfig.gamePlay.id && !isMaterialWarehouse() && node.sub_category ? h(
              'transName',
              {
                attrs: { name: node.name }
              },
              []
            ) : h(
              'p',
              {
                attrs: { title: node.name }
              },
              [node.name]
            ), canBeStar ? h(
              'starButton',
              {
                attrs: { category: node }
              },
              []
            ) : '', dcoCategoryArrowRight()]
          );
        }
      };
    }
  }),

  watch: {
    category: {
      handler: function handler() {
        this.currentCategoryList = this.getCurrentTabCategory();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    globalEventBus.$on(events.DM.OUTLINE.NAVIGATE, function (_ref2) {
      var id = _ref2.id,
          sceneId = _ref2.sceneId;
      return _this3.navigateToTargetOutlineCategory(id, sceneId);
    });

    this.currentCategoryList = this.getCurrentTabCategory();
    if (_2.isEmpty(this.currentCategoryList)) {
      return;
    }
    var getTargetCat = function getTargetCat() {
      var sceneCategoryList = findCatgeory({
        sub_category: _this3.category
      }, function (item) {
        return isSceneList(item.id);
      });
      var presetCategory = findCatgeory({
        sub_category: _this3.category
      }, function (cat) {
        return cat.id === categoryConfig.preset.id;
      });
      if (presetCategory) {
        return presetCategory;
      }
      if (_this3.isV2 && sceneCategoryList && !_2.isEmpty(sceneCategoryList.sub_category)) {
        return sceneCategoryList.sub_category[0];
      }
      return _this3.currentCategoryList[_2.findIndex(_this3.currentCategoryList, function (item) {
        return item.sub_category && item.sub_category.length > 0 && item.id !== categoryConfig.elementStars.id && item.id !== categoryConfig.multiCustomCategory.id;
      })];
    };
    this.switchCategory(getTargetCat());
  },
  destroyed: function destroyed() {
    globalEventBus.$off(events.DM.OUTLINE.NAVIGATE);
  },


  methods: _extends({}, mapMutations({
    changeDefaultGameDifficulty: 'creative/template/changeDefaultGameDifficulty',
    foldOutlineCategory: 'creative/template/foldOutlineCategory',
    updateOutlineCategory: 'creative/template/updateOutlineCategory',
    updateCurrentTab: 'creative/template/updateCurrentTab',
    updateActiveCategoryId: 'creative/template/updateActiveCategoryId',
    updateActiveCategoryNode: 'creative/template/updateActiveCategoryNode',
    categoryListBackToTop: 'creative/template/categoryListBackToTop'
  }), mapActions({
    addGameDifficulty: 'creative/template/addGameDifficulty'
  }), {
    getCurrentTabCategory: function getCurrentTabCategory() {
      var _this4 = this;

      if (Array.isArray(this.category)) {
        var currentCategory = this.category.find(function (item) {
          return item.id === _this4.currentTab;
        });
        return _2.get(currentCategory, 'sub_category') || [];
      }
      return [];
    },
    handleNodeClick: function handleNodeClick(node) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var valid;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this5.validate();

              case 2:
                valid = _context.sent;

                if (valid) _this5.switchCategory(node);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    handleSortClick: function handleSortClick() {
      this.$emit('update-sort-menu-dialog', {
        visible: true
      });
    },
    handleTransferClick: function handleTransferClick() {
      this.$emit('open-menu-transfer-dialog');
    },
    handleTabClick: function handleTabClick(tab) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var valid, getTargetNode, id, targetNode;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this6.validate();

              case 2:
                valid = _context2.sent;

                if (valid) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:
                getTargetNode = function getTargetNode(id) {
                  var node = null;
                  if (id === 3) {
                    node = _this6.category.find(function (item) {
                      return item.id === _this6.currentTab;
                    });
                  } else {
                    if (_this6.currentCategoryList && _this6.currentCategoryList.length) {
                      var index = _this6.currentCategoryList.findIndex(function (item) {
                        return item.visible && !isElementStars(item.id) && !isGameConfigStars(item.id);
                      });
                      if (index > -1) {
                        node = _this6.currentCategoryList[index];
                      }
                    }
                  }
                  return node;
                };

                id = Number(tab.id);

                _this6.updateCurrentTab(id);
                _this6.currentCategoryList = _this6.getCurrentTabCategory();
                targetNode = getTargetNode(id);


                if (targetNode) {
                  _this6.switchCategory(targetNode);
                } else {
                  _this6.switchCategory({ id: 'empty node' });
                }

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    switchCategory: function switchCategory(node) {
      if (node && node.id) {
        this.updateActiveCategoryNode(node);
        this.updateActiveCategoryId(node.id);
        if (isGameDifficultyCategory(node.id)) {
          this.changeDefaultGameDifficulty({ tag: node.tag });
          this.addGameDifficulty({ tag: node.tag, category: node });
        }
        this.categoryListBackToTop();
      } else {
        console.warn('switchCategory 发生错误，当前节点是：', node);
      }
    },
    handleFoldClick: function handleFoldClick(node) {
      this.foldOutlineCategory(node);
      this.updateOutlineCategory();
    },
    navigateToTargetOutlineCategory: function navigateToTargetOutlineCategory(id, sceneId) {
      var container = this.$refs['category-outline'];
      if (this.isV2) {
        var currentNode = container.querySelector('#scene-category-item-' + sceneId);
        if (currentNode) {
          animateScrollTo(currentNode, {
            elementToScroll: container.querySelector('.sub-category-list')
          });
        } else {
          console.log('没有找到目标分类');
        }
        // 滚动配置列表
        var srollBar = document.querySelector('#workspace-category-list');
        var currentItem = srollBar.querySelector('.group-item-' + id);
        if (currentItem) {
          animateScrollTo(currentItem, {
            elementToScroll: srollBar
          });
        } else {
          console.log('没有找到目标分类');
        }
      } else {
        var _currentNode = container.querySelector('#category-outline-' + id);
        if (_currentNode) {
          // 滚动侧栏菜单列表
          animateScrollTo(_currentNode, {
            elementToScroll: container.querySelector('.category-outline-bd')
          });
        } else {
          console.log('没有找到目标分类');
        }
      }
    }
  })
};